var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address",on:{"click":function($event){return _vm.$emit('select')}}},[_c('div',{staticClass:"address__info--jibun"},[_vm._v(_vm._s(_vm.address.jibunAddress))]),_c('span',{staticClass:"address__info--road"},[_c('span',{staticClass:"road-label"},[_vm._v("도로명")]),_vm._v(_vm._s(_vm.address.roadAddress)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }